import { IPOConfigFromBackend, IPOFromBackend } from '@app/@types/po/poConfig'

const extractInitialValues = (items: Array<IPOConfigFromBackend>): Array<IPOFromBackend> => items.map((item: IPOConfigFromBackend) => {
  const newItem = { number: Number(item.number), value: item.default.toString(), type: item.type }
  return newItem
})

export default extractInitialValues
